<template>
<div class="row align-center bibliotecafaq" id="faq">
  <div class="columns small-12 medium-12 large-10">
    <HomeSectionTitle :title="$t('UMA_LANG_SASUMA_FAQ')"/>
    <div class="faq">
      <div class="row align-center">
        <div class="small-12 medium-12 large-11 column">
          <div class="accordwrapper"
            data-equalizer
            data-equalize-on-stack="true">
                <ul class="accordion dp first"
                  data-accordion
                  data-allow-all-closed="true"
                  data-multi-expand="true"
                  :id="`deeplinked-accordion`">
                  <template v-for="faq in oddFaqsList">
                    <li 
                      :class="{'accordion-item': true, 'is-active': isExpanded(faq.inx)}"
                      @click.prevent="toggleAccordion(faq.inx)"
                      data-accordion-item >
                      <a href="#" class="accordion-title">
                        <div class="row" style="height: 40px;" data-equalizer-watch>
                          <div class="small-1 column">
                            <i class="fa fa-plus" v-if="!isExpanded(faq.inx)" />
                            <i class="fa fa-minus" v-if="isExpanded(faq.inx)" />
                          </div>
                          <div class="small-11 column">
                            <span>
                              {{faq.inx}}. {{ faq.docfaq_pergunta }}
                            </span>
                          </div>
                        </div>
                      </a>
                      <div class="accordion-content" data-tab-content :id="`item${faq.inx}`">
                        {{ faq.docfaq_resposta }}
                      </div>
                    </li>
                  </template>
                </ul>
                <ul class="accordion dp second"
                  data-accordion
                  data-allow-all-closed="true"
                  data-multi-expand="true"
                  :id="`deeplinked-accordion-2`">
                  <template v-for="faq in evenFaqsList">
                    <li 
                      :class="{'accordion-item': true, 'is-active': isExpanded(faq.inx)}"
                      @click.prevent="toggleAccordion(faq.inx)"
                      data-accordion-item >
                      <a href="#" class="accordion-title">
                        <div class="row" style="height: 40px;" data-equalizer-watch>
                          <div class="small-1 column">
                            <i class="fa fa-plus" v-if="!isExpanded(faq.inx)" />
                            <i class="fa fa-minus" v-if="isExpanded(faq.inx)" />
                          </div>
                          <div class="small-11 column">
                            <span>
                              {{faq.inx}}. {{ faq.docfaq_pergunta }}
                            </span>
                          </div>
                        </div>
                      </a>
                      <div class="accordion-content" data-tab-content :id="`item${faq.inx}`">
                        {{ faq.docfaq_resposta }}
                      </div>
                    </li>
                  </template>
                </ul>
          </div>

          <!-- responsive -->
          <div class="accordwrapper phone">
            <ul class="accordion dp"
              data-accordion
              data-allow-all-closed="true"
              data-multi-expand="true"
              id="deeplinked-accordion3">
              <template v-for="faq in sortedFaqs">
                <li :class="{'accordion-item': true, 'is-active': isExpanded(faq.inx)}"
                  @click.prevent="toggleAccordionMobile(faq.inx)"
                  data-accordion-item >
                    <a href="#" class="accordion-title">
                      <div class="row">
                        <div class="small-1 column">
                          <i class="fa fa-plus" v-if="!isExpanded(faq.inx)" />
                          <i class="fa fa-minus" v-if="isExpanded(faq.inx)" />
                        </div>
                        <div class="small-11 column">
                          <span>
                            {{faq.inx}}. {{ faq.docfaq_pergunta }}
                          </span>
                        </div>
                      </div>
                    </a>
                    <div class="accordion-content" data-tab-content :id="`itemm${faq.inx}`">
                      {{ faq.docfaq_resposta }}
                    </div>
                </li>
              </template>
            </ul>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import $ from 'jquery';
import 'foundation-sites';
import { onMounted, ref, nextTick } from "vue";
import axios from "@/axios";
import HomeSectionTitle from "@/components/HomeSectionTitle.vue";
import faqacc from "@/components/faqacc.vue";

export default {
  components: {
    HomeSectionTitle,
    faqacc
  },
  setup () {

    const oddFaqsList = ref([]);
    const evenFaqsList = ref([]);
    const sortedFaqs = ref([]);

    const getFaq = () => {
      axios.get(`/faq?unidadeId=${import.meta.env.VITE_APP_OWNER}`)
      .then(data => {
        sortedFaqs.value = data.data.data.map((el,) => {
          return {
            ...el,
            docfaq_ordem: el.docfaq_ordem == 0 ? Number.MAX_SAFE_INTEGER : el.docfaq_ordem
          }
        }).sort((a, b) => a.docfaq_ordem - b.docfaq_ordem)
          .map((el,index) => {
            return {
              ...el,
              inx: index+1
            }
          });
        oddFaqsList.value = sortedFaqs.value.filter(faq => faq.inx % 2 !== 0);
        evenFaqsList.value = sortedFaqs.value.filter(faq => faq.inx % 2 === 0);

      })
      .catch(error => {
        console.log(error);
      })
    }

    getFaq();

    const expandedItems = ref([]);

    const toggleAccordion = (index) => {
      const selector = `#item${index}`;
      const $content = $(selector);
      const position = expandedItems.value.indexOf(index);
      if (position > -1) {
        expandedItems.value.splice(position, 1);
        $content.slideUp(() => { });
      } else {
        expandedItems.value.push(index);
        $content.slideDown(() => { });
      }
    };

    const toggleAccordionMobile = (index) => {
      const selector = `#itemm${index}`;
      const $content = $(selector);
      const position = expandedItems.value.indexOf(index);
      if (position > -1) {
        expandedItems.value.splice(position, 1);
        $content.slideUp(() => { });
      } else {
        expandedItems.value.push(index);
        $content.slideDown(() => { });
      }
    };

    const isExpanded = (index) => expandedItems.value.includes(index);

    onMounted(()=> {
      nextTick(() => {
        const accord = $(".accordwrapper");
        $(accord).foundation();
        new Foundation.Equalizer($('.accordwrapper'));
      })
    })

    return {
      toggleAccordion,
      toggleAccordionMobile,
      isExpanded,
      evenFaqsList,
      oddFaqsList,
      sortedFaqs
    }
  }
}
</script>

<style lang="scss" scoped>
/*#region FAQ*/
.bibliotecafaq{
  background-color: #f3f3f5;
}

.faq{
    padding-top: 20px;
}

.faq > .row > .column{
    padding-right: 0;
    padding-left: 0;
}

.accordwrapper{
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  padding-bottom: 75px;
}
.dp{
  flex: 1 0 50%;
  background: transparent;
}

.dp.first{
  padding-right: 5px;
}

.dp.second{
  padding-left: 5px;
}

.dp li{
  margin-bottom: 10px;
  background: white;
}
.dp li a{
  font-family: "Montserrat SemiBold";
  font-size: 18px;
  color: rgb(10,10,10);
  border: 0;
  font-size: 17px;
  line-height: 20px;
  color: #333;
  border: 0;

}
.dp li i{
  margin-right: 15px;
  padding: 4px;
  background: /*rgb(74,88,172)*/#1380a0c4;
  color: white;
}
.dp li i.fa-minus{
  display: none;
}
.dp li.is-active i.fa-minus{
  display: inline-block;
}
.dp li.is-active i.fa-plus{
  display: none;
}
.dp .accordion-title:before{
  display: none;
}
.dp li .accordion-content{
  font-family: "Montserrat";
  font-size: 16px;
  padding-left: 53px;
  padding-right: 53px;
  padding-bottom: 45px;
  color: #333333;
}
.phone{
  display: none;
}

.bib_botao_ver {
  font-family: "Montserrat Bold";
}

.bib_botao_ver .accordion-title {
  color: #6eb7ec !important;
}

.ver_mais_cotas {
  font-family: 'Montserrat Bold';
  font-size: 15px!important;
}

.pesquisaonlineitem a p {
  text-align: center;
}

@media (max-width : 1024px){
  .accordwrapper{
    display: none;
  }
  .accordwrapper.phone{
    display: flex;
  }
}

@media (max-width : 767px){

  .faq {
    padding-top: 0px;
  }

  .dp li a {
    font-size: 14px;
  }

  .accordion-title {
    background-color: transparent;
    padding: 1.25rem 1rem !important;
  }

  .dp li .accordion-content {
    font-size: 14px;
    background-color: transparent;
  }

  .accordwrapper {
    padding-bottom: 45px;
  }
}
/*#endregion*/
</style>